import React from "react";

export default function PaperRow({ paper, id }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "60px 1fr",
        padding: "1rem 0",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <span style={{ color: "#9d4edd", fontSize: "1.6rem" }}>{id}</span>

      <div>
        {paper.title}
        <span
          style={{
            color: "white",
            marginLeft: "10px",
            fontSize: "1.4rem",
            textAlign: "right",
            backgroundColor: "#9d4edd",
          }}
        >
          {paper.slidesLink ? (
            <a
              href={paper.slidesLink}
              target="_blank"
              rel="noreferrer"
              style={{
                color: "white",
                textDecoration: "underline",
                padding: "0.2rem 0.6rem",
                display: "inline-block",
              }}
            >
              Link
            </a>
          ) : null}
        </span>
      </div>
    </div>
  );
}
